import { render } from "./vresourcesclassifyadd.vue?vue&type=template&id=dbc02b16&scoped=true"
import script from "./vresourcesclassifyadd.vue?vue&type=script&lang=js"
export * from "./vresourcesclassifyadd.vue?vue&type=script&lang=js"

import "./vresourcesclassifyadd.vue?vue&type=style&index=0&id=dbc02b16&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc02b16"]])

export default __exports__